import { render } from "./Tracking.vue?vue&type=template&id=c9a45460"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__